
export type ResolveOutboundResult = {
  isHttp: boolean;
  isOutbound: boolean;
  url?: URL;
  href: string;
  hostname?: string;
};

/**
 * Parses a link and returns information needed for tracking.
 *
 * - checks if the link uses HTTP(S)
 * - determines whether it is outbound (external) or internal
 * - returns parsed URL data (e.g. hostname) for tracking purposes
 *
 * This function is pure and does not trigger any tracking or navigation.
 */
export function getLinkTrackingInfo(
  href: string | null | undefined,
  opts?: { base?: string; isExternalOverride?: boolean }
): ResolveOutboundResult {
  const safeHref = href || "";
  try {
    const url = new URL(safeHref, opts?.base || (typeof window !== "undefined" ? window.location.origin : undefined));
    const isHttp = url.protocol === "http:" || url.protocol === "https:";
    if (!isHttp) {
      return { isHttp: false, isOutbound: false, href: safeHref, url };
    }
    if (typeof opts?.isExternalOverride === "boolean") {
      return {
        isHttp: true,
        isOutbound: opts.isExternalOverride,
        href: url.href,
        url,
        hostname: url.hostname,
      };
    }
    const isOutbound =
      typeof window !== "undefined" ? url.origin !== window.location.origin : false;
    return { isHttp: true, isOutbound, href: url.href, url, hostname: url.hostname };
  } catch {
    return { isHttp: false, isOutbound: false, href: safeHref };
  }
}


